var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
const _require = require('../lib/evaluateSource'),
  evaluateSource = _require.evaluateSource;
const stripUndefined = obj => Object.fromEntries(
// eslint-disable-next-line no-unused-vars
Object.entries(obj).filter(_ref => {
  let _ref2 = _slicedToArray(_ref, 2),
    _k = _ref2[0],
    v = _ref2[1];
  return v !== undefined;
}));

/**
  * @function evalute - evaluate writeCurrentLocationBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const targetContentPath = await evaluateSource(source.targetContentPath, content, parentContentPath, transientContext, nativeFunctions);
  if (targetContentPath === undefined) {
    return;
  }
  const querySource = {
    type: 'currentLocationBehavior',
    includeHighAccuracyFields: true
  };
  const location = await evaluateSource(querySource, content, parentContentPath, transientContext, nativeFunctions);
  if (location === undefined || location === null) {
    return;
  }
  const logContentPath = await evaluateSource(source.logContentPath, content, parentContentPath, transientContext, nativeFunctions);
  let displayValue;
  let breadcrumbs;
  const fields = await evaluateSource(source.fields, content, parentContentPath, transientContext, nativeFunctions);
  if (fields !== undefined && Array.isArray(fields)) {
    Object.keys(location).forEach(key => {
      if (!fields.includes(key)) {
        delete location[key];
      }
    });
  }
  if (logContentPath !== undefined) {
    const displayValues = [];
    const displayMap = {
      latitude: "Latitude to ".concat(location.latitude),
      longitude: "Longitude to ".concat(location.longitude),
      rawElevation: "Raw elevation to ".concat(location.rawElevation, " m"),
      poleAdjustedElevation: "Pole-adjusted elevation to ".concat(location.poleAdjustedElevation, " m"),
      verticalAccuracy: "Vertical accuracy to ".concat(location.verticalAccuracy, " m"),
      horizontalAccuracy: "Horizontal accuracy to ".concat(location.horizontalAccuracy, " m"),
      desiredMinimumHorizontalAccuracy: "Desired minimum horizontal accuracy to ".concat(location.desiredMinimumHorizontalAccuracy, " m"),
      desiredMinimumVerticalAccuracy: "Desired minimum vertical accuracy to ".concat(location.desiredMinimumVerticalAccuracy, " m"),
      hDop: "Horizontal Dillution of Precision to ".concat(location.hDop),
      vDop: "Vertical Dillution of Precision to ".concat(location.vDop),
      pDop: "Position (3D) Dillution of Precision to ".concat(location.pDop),
      timestamp: "Capture date/time to ".concat(location.timestamp),
      gpsQuality: "GPS quality to ".concat(location.gpsQuality),
      coordinateReference: "Coordinate reference model to ".concat(location.coordinateReference),
      epoch: "Epoch of the coordinate reference model to ".concat(location.epoch),
      numberSatellitesUsed: "Number of satellites used to ".concat(location.numberSatellitesUsed),
      numberSatellitesInView: "Number of satellites in view to ".concat(location.numberSatellitesInView),
      coordinateSource: "Capture device to ".concat(location.coordinateSource)
    };
    Object.keys(displayMap).forEach(key => {
      if (location[key] !== undefined) {
        displayValues.push(displayMap[key]);
      }
    });
    displayValue = displayValues.join(', ');
    breadcrumbs = await evaluateSource(source.breadcrumbs, content, parentContentPath, transientContext, nativeFunctions);
  }
  const writeSource = {
    type: 'writeContentBehavior',
    targetContentPath,
    source: location,
    logContentPath,
    displayValue,
    breadcrumbs
  };
  await evaluateSource(stripUndefined(writeSource), content, parentContentPath, transientContext, nativeFunctions);
};
module.exports = {
  evaluate
};